(() => {
  const storageKey = 'eleat-purchase-journey-started-v1';
  const watched = new WeakSet();
  let started = false;
  try { started = sessionStorage.getItem(storageKey) === '1'; } catch (_) {}

  const closePromotion = () => {
    window.alia = window.alia || [];
    if (typeof window.alia.push === 'function') window.alia.push({ type: 'close' });
  };
  const protectJourney = () => {
    if (started && document.documentElement.dataset.eleatPurchaseStarted === 'true') return;
    started = true;
    document.documentElement.dataset.eleatPurchaseStarted = 'true';
    try { sessionStorage.setItem(storageKey, '1'); } catch (_) {}
    closePromotion();
  };
  if (started) protectJourney();

  document.addEventListener('alia:campaignMatched', () => { if (started) closePromotion(); });
  document.addEventListener('alia:popupView', () => { if (started) closePromotion(); });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.product-template__plan-cta');
    if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') protectJourney();
  }, true);

  const watch = (node, options, inspect) => {
    if (watched.has(node)) return;
    watched.add(node);
    const observer = new MutationObserver(inspect);
    observer.observe(node, options);
    inspect();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(node)) observer.disconnect();
    });
  };
  const initialise = () => {
    document.querySelectorAll('.product-template__form-flavour-heading').forEach(node => {
      watch(node, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] }, () => {
        if (!node.hidden && !node.classList.contains('hidden') && getComputedStyle(node).display !== 'none') protectJourney();
      });
    });
    document.querySelectorAll('#build-a-bundle .build-a-bundle__progress-bar-count-current, #build-a-bundle .build-a-bundle__count').forEach(node => {
      watch(node, { childList: true, characterData: true, subtree: true }, () => {
        if (Number.parseInt(node.textContent, 10) > 0) protectJourney();
      });
    });
    document.querySelectorAll('.cart-aside').forEach(node => {
      watch(node, { attributes: true, attributeFilter: ['class'] }, () => {
        if (node.classList.contains('cart-aside--active')) protectJourney();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  window.addEventListener('pageshow', () => { if (started) closePromotion(); });
})();
